<template>
  <div class="chatbot-container">
    <div class="workup-pond">
      <div class="workup-screen">
        <div id="chatBody" class="workup-container">
          <button class="btn-chatClose" @click="emit('closeChat')"></button>
          <iframe width="380px" height="572px" class="iframe100" :src=chatURL frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script setup>
// import { watch,ref,computed } from 'vue';

// const props = defineProps({
//   tenantKey: String,
// })

const emit = defineEmits(['closeChat']);
// const isProd=window.location.host.indexOf("hr.")>-1
// const host = computed(()=>isProd?"hrchat.workup.plus":"aiagent.workup.plus")

// const baseURL = computed(()=>"https://hrchat.workup.plus/workup-aiagent-chatbot-admin/recruitModelTest");

const chatURL = "https://hrchat.workup.plus/workup-aiagent-chatbot-admin/recruitModelTest"

// watch(() => props.tenantKey, (newVal) => {
//   // console.log(isProd?"chatbot Init":"cahtbot init");
//   chatURL.value = baseURL.value + newVal+ "&serviceYN=Y"
// })

</script>